import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import prop from 'ramda/src/prop'
import equals from 'ramda/src/equals'
import compose from 'ramda/src/compose'
import omit from 'ramda/src/omit'
import assoc from 'ramda/src/assoc'
import has from 'ramda/src/has'

import { PLEDGE_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import currentRouteParamsRecordId	from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import propEq from 'ramda/src/propEq'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import { NO_CAMPAIGN_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'
import paymentTypes from 'root/src/shared/constants/paymentTypes'

export default formData => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)
	const paymentType = prop('paymentType', formData)
	if (equals(paymentType, paymentTypes.brandProduct)) {
		const paymentInfo = {
			paymentType,
			brandProductId: prop('id', formData.products),
			productType: prop('type', formData.products),
			amount: formData.amount,
		}
		if (propEq('productType', brandProductTypesEnum.dropKey, paymentInfo)) {
			if (!paymentInfo.amount) {
				throw {
					amount: 'Keys are required',
				}
			}
		}

		const payload = compose(
			assoc('paymentInfo', paymentInfo),
			assoc('projectUrl', projectUrl),
			omit(['pledgeAmount', 'paymentType', 'products', 'amount']),
		)(formData)
		const { error, body } = await dispatch(apiRequest(PLEDGE_PROJECT, payload))
		if (error) {
			if (error.code === 'NotEnoughKeys') {
				throw {
					amount: 'Not enough keys',
				}
			}
			if (error.code === 'Forbidden') {
				dispatch(displayModal(NO_CAMPAIGN_MODAL_MODULE_ID))
				throw {}
			}
			if (error.code === 'PayloadSchemaError' && has('paymentInfo', error.message)) {
				throw error.message.paymentInfo
			}
		}
		return { error, body }
	}
	return undefined
}
